var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticStyle: { top: "20px", height: "95%" },
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        keyboard: false,
        forceRender: true,
        prefixNo: _vm.prefixNo,
        fullscreen: "",
        switchFullscreen: "",
        id: _vm.prefixNo,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")]),
          _vm.billPrintFlag && _vm.isShowPrintBtn
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlePrintPro("销售退货入库")
                    },
                  },
                },
                [_vm._v("三联打印-新版")]
              )
            : _vm._e(),
          _vm.billPrintFlag && _vm.isShowPrintBtn
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handlePrint("销售退货入库")
                    },
                  },
                },
                [_vm._v("三联打印")]
              )
            : _vm._e(),
          _vm.checkFlag && _vm.isCanCheck
            ? _c(
                "a-button",
                {
                  attrs: { loading: _vm.confirmLoading },
                  on: { click: _vm.handleOkAndCheck },
                },
                [_vm._v("保存并审核")]
              )
            : _vm._e(),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.handleOkOnly },
            },
            [_vm._v("保存（Ctrl+S）")]
          ),
          !_vm.checkFlag
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleWorkflow()
                    },
                  },
                },
                [_vm._v("提交流程")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "客户",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "organId",
                                    _vm.validatorRules.organId,
                                  ],
                                  expression:
                                    "[ 'organId', validatorRules.organId ]",
                                },
                              ],
                              attrs: {
                                placeholder: "请选择客户",
                                disabled: !_vm.rowCanEdit,
                                dropdownMatchSelectWidth: false,
                                showSearch: "",
                                optionFilterProp: "children",
                              },
                              on: {
                                change: _vm.handleOrganChange,
                                search: _vm.handleSearchCustomer,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "dropdownRender",
                                  fn: function (menu) {
                                    return _c(
                                      "div",
                                      {},
                                      [
                                        _c("v-nodes", {
                                          attrs: { vnodes: menu },
                                        }),
                                        _c("a-divider", {
                                          staticStyle: { margin: "4px 0" },
                                        }),
                                        _vm.quickBtn.customer
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-btn",
                                                on: {
                                                  mousedown: (e) =>
                                                    e.preventDefault(),
                                                  click: _vm.addCustomer,
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "plus" },
                                                }),
                                                _vm._v(" 新增客户"),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-btn",
                                            on: {
                                              mousedown: (e) =>
                                                e.preventDefault(),
                                              click: function ($event) {
                                                return _vm.initCustomer(0)
                                              },
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "reload" },
                                            }),
                                            _vm._v(" 刷新列表"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  },
                                },
                              ]),
                            },
                            _vm._l(_vm.cusList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.supplier) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据日期",
                          },
                        },
                        [
                          _c("j-date", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "operTime",
                                  _vm.validatorRules.operTime,
                                ],
                                expression:
                                  "['operTime', validatorRules.operTime]",
                              },
                            ],
                            attrs: { "show-time": true },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "单据编号",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["number", _vm.validatorRules.number],
                                expression:
                                  "[ 'number', validatorRules.number ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入单据编号" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "关联单据",
                          },
                        },
                        [
                          _c("a-input-search", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["linkNumber"],
                                expression: "[ 'linkNumber' ]",
                              },
                            ],
                            attrs: {
                              placeholder: "请选择关联单据",
                              readOnly: true,
                            },
                            on: { search: _vm.onSearchLinkNumber },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("j-editable-table", {
                ref: _vm.refKeys[0],
                attrs: {
                  id: "billModal",
                  loading: _vm.materialTable.loading,
                  columns: _vm.materialTable.columns,
                  dataSource: _vm.materialTable.dataSource,
                  minWidth: _vm.minWidth,
                  maxHeight: 300,
                  rowNumber: false,
                  rowSelection: true,
                  actionButton: _vm.rowCanEdit,
                  actionDeleteButton: !_vm.rowCanEdit,
                  dragSortAndNumber: _vm.rowCanEdit,
                },
                on: {
                  valueChange: _vm.onValueChange,
                  added: _vm.onAdded,
                  deleted: _vm.onDeleted,
                },
                scopedSlots: _vm._u([
                  {
                    key: "buttonAfter",
                    fn: function () {
                      return [
                        _vm.rowCanEdit
                          ? _c(
                              "a-row",
                              {
                                staticStyle: {
                                  float: "left",
                                  "padding-bottom": "5px",
                                  "padding-right": "8px",
                                },
                                attrs: {
                                  gutter: 24,
                                  "data-step": "4",
                                  "data-title": "扫码录入",
                                  "data-intro":
                                    "此功能支持扫码枪扫描商品条码进行录入",
                                },
                              },
                              [
                                _vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      { attrs: { md: 6, sm: 24 } },
                                      [
                                        _c(
                                          "a-button",
                                          {
                                            staticStyle: {
                                              "margin-right": "8px",
                                            },
                                            on: { click: _vm.scanEnter },
                                          },
                                          [_vm._v("扫码录入")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      {
                                        staticStyle: {
                                          padding: "0 8px 0 12px",
                                        },
                                        attrs: { md: 16, sm: 24 },
                                      },
                                      [
                                        _c("a-input", {
                                          ref: "scanBarCode",
                                          attrs: {
                                            placeholder: "请扫描商品条码并回车",
                                          },
                                          on: {
                                            pressEnter: _vm.scanPressEnter,
                                          },
                                          model: {
                                            value: _vm.scanBarCode,
                                            callback: function ($$v) {
                                              _vm.scanBarCode = $$v
                                            },
                                            expression: "scanBarCode",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.scanStatus
                                  ? _c(
                                      "a-col",
                                      {
                                        staticStyle: {
                                          padding: "0px 24px 0 0",
                                        },
                                        attrs: { md: 6, sm: 24 },
                                      },
                                      [
                                        _c(
                                          "a-button",
                                          {
                                            staticStyle: {
                                              "margin-right": "8px",
                                            },
                                            on: { click: _vm.stopScan },
                                          },
                                          [_vm._v("收起扫码")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "depotBatchSet",
                    fn: function () {
                      return [
                        _c("a-icon", {
                          attrs: { type: "down" },
                          on: { click: _vm.handleBatchSetDepot },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "depotAdd",
                    fn: function () {
                      return [
                        _vm.quickBtn.depot
                          ? _c("a-divider", {
                              staticStyle: { margin: "4px 0" },
                            })
                          : _vm._e(),
                        _vm.quickBtn.depot
                          ? _c(
                              "div",
                              {
                                staticClass: "dropdown-btn",
                                on: { click: _vm.addDepot },
                              },
                              [
                                _c("a-icon", { attrs: { type: "plus" } }),
                                _vm._v(" 新增"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-btn",
                            on: {
                              mousedown: (e) => e.preventDefault(),
                              click: _vm.initDepot,
                            },
                          },
                          [
                            _c("a-icon", { attrs: { type: "reload" } }),
                            _vm._v(" 刷新"),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 24, md: 24, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
                            label: "",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["remark"],
                                expression: "[ 'remark' ]",
                              },
                            ],
                            staticStyle: { "margin-top": "8px" },
                            attrs: { rows: 1, placeholder: "请输入备注" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "优惠率",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["discount"],
                                expression: "[ 'discount' ]",
                                modifiers: { trim: true },
                              },
                            ],
                            staticStyle: { width: "80%" },
                            attrs: { placeholder: "请输入优惠率", suffix: "%" },
                            on: { change: _vm.onChangeDiscount },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "退款优惠",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["discountMoney"],
                                expression: "[ 'discountMoney' ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入退款优惠" },
                            on: { change: _vm.onChangeDiscountMoney },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "优惠后金额",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["discountLastMoney"],
                                expression: "[ 'discountLastMoney' ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: {
                              placeholder: "请输入优惠后金额",
                              readOnly: true,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "其它费用",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["otherMoney"],
                                expression: "[ 'otherMoney' ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入其它费用" },
                            on: { change: _vm.onChangeOtherMoney },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "结算账户",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "accountId",
                                    _vm.validatorRules.accountId,
                                  ],
                                  expression:
                                    "[ 'accountId', validatorRules.accountId ]",
                                },
                              ],
                              staticStyle: { width: "80%" },
                              attrs: {
                                placeholder: "请选择结算账户",
                                dropdownMatchSelectWidth: false,
                                allowClear: "",
                              },
                              on: { select: _vm.selectAccount },
                              scopedSlots: _vm._u([
                                {
                                  key: "dropdownRender",
                                  fn: function (menu) {
                                    return _c(
                                      "div",
                                      {},
                                      [
                                        _c("v-nodes", {
                                          attrs: { vnodes: menu },
                                        }),
                                        _c("a-divider", {
                                          staticStyle: { margin: "4px 0" },
                                        }),
                                        _vm.quickBtn.account
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-btn",
                                                on: {
                                                  mousedown: (e) =>
                                                    e.preventDefault(),
                                                  click: _vm.addAccount,
                                                },
                                              },
                                              [
                                                _c("a-icon", {
                                                  attrs: { type: "plus" },
                                                }),
                                                _vm._v(" 新增"),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-btn",
                                            on: {
                                              mousedown: (e) =>
                                                e.preventDefault(),
                                              click: function ($event) {
                                                return _vm.initAccount(0)
                                              },
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              attrs: { type: "reload" },
                                            }),
                                            _vm._v(" 刷新"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  },
                                },
                              ]),
                            },
                            _vm._l(_vm.accountList, function (item, index) {
                              return _c(
                                "a-select-option",
                                { key: index, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.name) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _c(
                            "a-tooltip",
                            { attrs: { title: "多账户明细" } },
                            [
                              _c("a-button", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.manyAccountBtnStatus,
                                    expression: "manyAccountBtnStatus",
                                  },
                                ],
                                staticStyle: { "margin-left": "8px" },
                                attrs: {
                                  type: "default",
                                  icon: "folder",
                                  size: "small",
                                },
                                on: { click: _vm.handleManyAccount },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "本次退款",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["changeAmount"],
                                expression: "[ 'changeAmount' ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { placeholder: "请输入本次退款" },
                            on: { change: _vm.onChangeChangeAmount },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "本次欠款",
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator.trim",
                                value: ["debt"],
                                expression: "[ 'debt' ]",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: {
                              placeholder: "请输入本次欠款",
                              readOnly: true,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "销售人员",
                          },
                        },
                        [
                          _c("j-select-multiple", {
                            attrs: {
                              placeholder: "请选择销售人员",
                              options: _vm.personList.options,
                            },
                            model: {
                              value: _vm.personList.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.personList, "value", $$v)
                              },
                              expression: "personList.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                { staticClass: "form-row", attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 12, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "附件",
                          },
                        },
                        [
                          _c("j-upload", {
                            attrs: { bizPath: "bill" },
                            model: {
                              value: _vm.fileList,
                              callback: function ($$v) {
                                _vm.fileList = $$v
                              },
                              expression: "fileList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("many-account-modal", {
        ref: "manyAccountModalForm",
        on: { ok: _vm.manyAccountModalFormOk },
      }),
      _c("link-bill-list", {
        ref: "linkBillList",
        on: { ok: _vm.linkBillListOk },
      }),
      _c("customer-modal", {
        ref: "customerModalForm",
        on: { ok: _vm.customerModalFormOk },
      }),
      _c("depot-modal", {
        ref: "depotModalForm",
        on: { ok: _vm.depotModalFormOk },
      }),
      _c("account-modal", {
        ref: "accountModalForm",
        on: { ok: _vm.accountModalFormOk },
      }),
      _c("batch-set-depot", {
        ref: "batchSetDepotModalForm",
        on: { ok: _vm.batchSetDepotModalFormOk },
      }),
      _c("workflow-iframe", {
        ref: "modalWorkflow",
        on: { ok: _vm.workflowModalFormOk },
      }),
      _c("bill-print-iframe", { ref: "modalPrint" }),
      _c("bill-print-pro-iframe", { ref: "modalPrintPro" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }